import { CANCEL_BOOKING_STATE } from './constants'

export const getIsFetching = hash => state =>
  state[CANCEL_BOOKING_STATE]?.bookings[hash]?.isFetching
export const getStatus = hash => state => state[CANCEL_BOOKING_STATE]?.bookings[hash]?.status

export const getAllStatuses = state =>
  Object.keys(state[CANCEL_BOOKING_STATE]?.bookings).map(
    hash => state[CANCEL_BOOKING_STATE]?.bookings[hash].status
  )

export const getAllErrorCodes = state =>
  Object.keys(state[CANCEL_BOOKING_STATE]?.bookings).map(
    hash => state[CANCEL_BOOKING_STATE]?.bookings[hash].errorCode
  )
